import types from 'actions/types'
import Immutable from 'seamless-immutable'
import { get } from 'lodash'
import { combineReducers } from 'redux'
import { createPivotTableReducer } from 'reducers/pivotTable'

export const invoicingContextSelectorInvoicesPivotTableKey = 'invoicingContext.selector.invoices'

const search = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_INVOICE_SELECTOR_SEARCH: return action.search
    default: return state
  }
}

const status = (state = Immutable(null), action) => {
  switch (action.type) {
    case types.INVOICING_INVOICE_SELECTOR_UPDATE_FILTERS: return get(action, 'filters.status', state)
    default: return state
  }
}

const companyId = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_INVOICE_SELECTOR_UPDATE_FILTERS: return get(action, 'filters.companyId', state)
    default: return state
  }
}

const targetStart = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_INVOICE_SELECTOR_UPDATE_FILTERS: return get(action, 'filters.targetStart', state)
    default: return state
  }
}

const targetEnd = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_INVOICE_SELECTOR_UPDATE_FILTERS: return get(action, 'filters.targetEnd', state)
    default: return state
  }
}

const creatorId = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_INVOICE_SELECTOR_UPDATE_FILTERS: return get(action, 'filters.creatorId', state)
    default: return state
  }
}

const estimatorId = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_INVOICE_SELECTOR_UPDATE_FILTERS: return get(action, 'filters.estimatorId', state)
    default: return state
  }
}

const timeKey = (state = Immutable('month:0'), action) => {
  switch (action.type) {
    case types.INVOICING_INVOICE_SELECTOR_UPDATE_FILTERS: return get(action, 'filters.timeKey', state)
    default: return state
  }
}

const itemsInvoice = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_INVOICE_SELECTOR_LOAD_ITEMS: return action.invoiceId
    default: return state
  }
}

const showLineItems = (state = false, action) => {
  switch (action.type) {
    case types.INVOICING_INVOICE_SELECTOR_TOGGLE_ITEMS: return action.showLineItems
    default: return state
  }
}

const orderTypeId = (state = false, action) => {
  switch (action.type) {
    case types.INVOICING_INVOICE_SELECTOR_UPDATE_FILTERS: return action.orderTypeId
    default: return state
  }
}

export default combineReducers({
  invoices: createPivotTableReducer({key: invoicingContextSelectorInvoicesPivotTableKey, defaultSortColumn: 'createdDate', defaultSortDirection: 'desc'}),
  items: createPivotTableReducer({key: 'invoicingContext.selector.items', defaultSortColumn: Immutable('itemId'), defaultSortDirection: Immutable('asc'), pageSize: 100}),
  search,
  status,
  companyId,
  targetStart,
  targetEnd,
  creatorId,
  estimatorId,
  timeKey,
  itemsInvoice,
  showLineItems,
  orderTypeId,
})
